import React, { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Header } from './Header';
import { Footer } from './Footer';
import { NavDrawer } from './NavDrawer';
import { AnnouncementBar } from './AnnouncementBar';
import { StickyBuyBar, STICKY_BAR_ROUTES } from '../shop/StickyBuyBar';
import { PurchaseFlowModal } from '../shop/PurchaseFlowModal';
import { NavDrawerProvider } from '../../contexts/NavDrawerContext';
import { initMetaPixel, track } from '../../utils/analytics';
export function SiteLayout() {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    initMetaPixel();
  }, []);
  useEffect(() => {
    window.scrollTo({
      top: 0
    });
    track('page_view', {
      path: pathname
    });
  }, [pathname]);
  return <NavDrawerProvider data-id="element-359" data-mp="3rvesq5psac5i">
      <div className="flex min-h-screen w-full flex-col bg-deep text-white" data-id="element-360" data-mp="347x7yu4xsec1">
        <a href="#main" className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-50 focus:rounded focus:bg-marine focus:px-4 focus:py-2" data-id="element-361" data-mp="345u6ndyc2ys0">
          Skip to content
        </a>
        <AnnouncementBar data-id="element-362" data-mp="1fbondi4yv8zo" />
        <Header data-id="element-363" data-mp="1fawre67gj98v" />
        <main id="main" className="flex-1" data-id="element-364" data-mp="1fadi1dvvht6g">
          <Outlet data-id="element-365" data-mp="1k2n8cv0wgv99" />
        </main>
        <Footer data-id="element-366" data-mp="1k3pw4u2xehky" />
        {/* Room for the mobile sticky purchase bar so it never covers the footer. */}
        {STICKY_BAR_ROUTES.includes(pathname) && <div className="h-20 lg:hidden" aria-hidden data-id="element-367" data-mp="1o62zxcy445f3" />}
        <StickyBuyBar data-id="element-368" data-mp="rf121f0afcip" />
        <NavDrawer data-id="element-369" data-mp="rfu1duwx2zqt" />
        <PurchaseFlowModal data-id="element-370" data-mp="rgc7dj9dssbx" />
      </div>
    </NavDrawerProvider>;
}